export default "__VITE_ASSET__PVVNu3nT__"